/** Apertum mainnet (2786) — getting-started / wallets skill. */

export const APERTUM_CHAIN_ID = 2786;
export const APERTUM_CHAIN_ID_HEX = '0xae2';

export const APERTUM_RPC =
  'https://rpc.apertum.io/ext/bc/YDJ1r9RMkewATmA7B35q1bdV18aywzmdiXwd9zGBq3uQjsCnn/rpc';

export const APERTUM_EXPLORER = 'https://explorer.apertum.io';

/** Wrapped APTM (DEX WETH) — wallet dropdown balance. */
export const WAPTM_TOKEN = '0x110Ac02Ba3384Bc055c13A87766049a74517BedA';
/** SportsFuture (SFUT) token — wallet dropdown balance. */
export const SFUT_TOKEN = '0xA8532d029320AD0176EfD0959e044aA610A751Ed';

/**
 * Apertum Multicall3 (same deployment OpenPlaza uses).
 * The usual CREATE2 address 0xcA11…CA11 has no bytecode on 2786 / 89898.
 */
export const MULTICALL3_ADDRESS = '0x7e168E30Db12C2ED4cc3fe06C25caa1a6e99cC3A';

export const APERTUM_ADD_CHAIN_PARAMS = {
  chainId: APERTUM_CHAIN_ID_HEX,
  chainName: 'Apertum',
  nativeCurrency: { name: 'Apertum', symbol: 'APTM', decimals: 18 },
  rpcUrls: [APERTUM_RPC],
  blockExplorerUrls: [`${APERTUM_EXPLORER}/`],
} as const;

export function explorerAddressUrl(address: string): string {
  return `${APERTUM_EXPLORER}/address/${address}`;
}

export function formatAddress(address: string): string {
  if (!address || address.length < 10) return address;
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

export function parseChainId(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const n = value.startsWith('0x') ? parseInt(value, 16) : Number(value);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}
